export const PATH_ROOT = '/' ;
export const PATH_HOME_ROOT = '/home' ;
export const PATH_ADMIN_ROOT = '/home/admin' ;
export const PATH_ADMIN_ROOT_LINK = '/home/admin' ;
export const PATH_ADMIN_DOMAINS = '/home/admin/domains' ;
export const PATH_ADMIN_ORGANISATIONS = '/home/admin/organisations' ;
export const PATH_SAFEGUARDING_ROOT = '/home/safeguarding/:user_type?' ;
export const PATH_SAFEGUARDING_ROOT_LINK = '/home/safeguarding' ;
export const PATH_PRIVATE_MESSAGING_ROOT = '/home/private-messaging' ;
export const PATH_PRIVATE_MESSAGING_ROOT_LINK = '/home/private-messaging' ;
export const PATH_COMMSPLANS_ROOT = '/home/commsplans' ;
export const PATH_LETTERBOX_ROOT = '/home/letterbox' ;
export const PATH_LETTERBOX_LETTERBOX = '/home/letterbox/letterbox' ;
export const PATH_LETTERBOX_CALENDAR = '/home/letterbox/calendar' ;
export const PATH_POSTS_ROOT = '/home/posts' ;
export const PATH_POSTS_POSTS = '/home/posts/posts' ;
export const PATH_POSTS_DASHBOARD = '/home/posts/dashboard' ;
export const PATH_CHILD_ROOT = '/home/child/:child_uid?' ;
export const PATH_CHILD_ROOT_LINK = '/home/child' ;
export const PATH_CONTACT_ROOT = '/home/contact/:user_id?' ;
export const PATH_CONTACT_ROOT_LINK = '/home/contact' ;
export const PATH_TEAM_ROOT = '/home/team/:team_id?' ;
export const PATH_TEAM_ROOT_LINK = '/home/team' ;
export const PATH_TEAM_USER_CONNECTION = '/home/team/:team_id/users/:user_id/connections' ;
export const PATH_TEAM_USER_DASHBOARD = '/home/team/:team_id/users/:user_id/dashboard' ;
export const PATH_MESSAGING_ROOT = '/home/messaging' ;
export const PATH_MESSAGING_MESSAGING = '/home/messaging/messaging' ;
export const PATH_DASHBOARD_ROOT = '/home/dashboard' ;
export const PATH_USERS_ROOT_LINK = '/home/users' ;
export const PATH_USERS_ROOT = '/home/users/:user_type?' ;
export const PATH_USERS_DASHBOARD = '/home/users/dashboard' ;
export const PATH_USERS_CONNECTIONS = '/home/users/:user_id/connections' ;
export const PATH_USERS_SUMMARY = '/home/users/:user_id/dashboard' ;
export const PATH_RESOURCES_ROOT = '/home/resources' ;
export const PATH_MY_CONTRIBUTORS_ROOT = '/home/mycontributors' ;
export const PATH_MY_CONTRIBUTOR_SUMMARY = '/home/mycontributors/:user_id/dashboard' ;
export const PATH_APPROVALS_ROOT = '/home/approvals' ;

//LINKS
export const getChildRouterLink = (child_uid, subKey ) =>
{
    return '/home/child/' + child_uid + '/' + subKey ;
}

export const getContactRouterLink = (user_id, subKey ) =>
{
    return '/home/contact/' + user_id + '/' + subKey ;
}

export const getTeamRouterLink = (team_id, subKey ) =>
{
    return '/home/team' + '/' + team_id + '/' + subKey ;
}

export const getPostRouterLink = (subKey ) =>
{
    return '/home/posts' + '/' + subKey ;
}

export const getDashboardRouterLink = (subKey ) =>
{
    return '/home/dashboard' + subKey ;
}

export const getAdminRouterLink = (subKey ) =>
{
    return '/home/admin/' + subKey ;
}

export const getAdminRouterPath = (subKey ) =>
{
    return subKey === null || subKey === undefined ? '/home/admin' : '/home/admin/' + subKey ;
}

export const getUsersRouterLink = (subKey ) =>
{
    return '/home/users/' + subKey ;
}

export const getApprovalsRouterLink = (subKey ) =>
{
    return '/home/approvals/' + subKey ;
}

export const getResourcesRouterLink = (subKey ) =>
{
    return '/home/resources/' + subKey ;
}

export const getLetterboxRouterLink = (subKey ) =>
{
    return '/home/letterbox/' + subKey ;
}

export const getMessagingRouterLink = (subKey ) =>
{
    return '/home/messaging/' + subKey ;
}

export const getSafeguardingRouterLink = (subKey ) =>
{
    return '/home/safeguarding/' + subKey ;
}

export const privateMessagingRouterLink = (subKey ) =>
{
    return '/home/private-messaging/' + ( subKey === null ? '' : subKey );
}

//PATHS
export const getTeamRouterPath = ( subKey ) =>
{
    return '/home/team/:team_id/' + subKey ;
}

export const getChildRouterPath = ( subKey ) =>
{
    return '/home/child/:child_uid/' + subKey ;
}

export const getContactRouterPath = ( subKey ) =>
{
    return '/home/contact/:user_uid/' + subKey ;
}

export const getDashboardRouterPath = ( subKey ) =>
{
    return '/home/dashboard/' + subKey ;
}

export const getUsersRouterPath = ( subKey ) =>
{
    return '/home/users/' + subKey ;
}

export const getSafeguardingRouterPath = ( subKey ) =>
{
    return '/home/safeguarding/' + subKey ;
}

export const getMyContributorsRouterLink = (subKey ) =>
{
    return '/home/mycontributors/' + subKey ;
}